<template>
  <section
    class="opputunity-container frommobile-alignunset mobalign-center overflow-hidden w-100 position-relative w-100 lapflex-between"
  >
    <!-- <div class="position-relative left-0 h-100"> -->
    <div id="laptophidden" class="biggerphones-alignment">
      <img
        src="../../assets/imgs/Recruitment/transitionimages/mobtoppink.svg"
        alt="Hire3x pink transition visual - Left 1"
        class="animated-img left1"
      />
      <img
        src="../../assets/imgs/Recruitment/transitionimages/mobtoporange.svg"
        class="animated-img left2"
        alt="Hire3x orange transition element - Left 2"
      />
      <img
        src="../../assets/imgs/Recruitment/transitionimages/mobtopgreeb.svg"
        class="animated-img left3"
        alt="Hire3x green transition shape - Left 3"
      />
      <img
        src="../../assets/imgs/Recruitment/transitionimages/mobtopb.svg"
        class="animated-img mobtop4"
        alt="Hire3x blue transition shape - Top 4"
      />
      <img
        src="../../assets/imgs/Recruitment/transitionimages/msg.svg"
        class="animated-img mobtop5"
        alt="Hire3x message icon - Top 5"
      />
      <img
        src="../../assets/imgs/Recruitment/transitionimages/pause.svg"
        class="animated-img mobtop6"
        alt="Hire3x pause icon - Top 6"
      />
      <img
        src="../../assets/imgs/Recruitment/transitionimages/cube.svg"
        class="animated-img mobtop7"
        alt="Hire3x 3D cube element - Top 7"
      />
      <img
        src="../../assets/imgs/Recruitment/transitionimages/cash.svg"
        class="animated-img mobtop8"
        alt="Hire3x cash icon - Top 8"
      />

      <img
        src="../../assets/imgs/Recruitment/transitionimages/cube.svg"
        class="animated-img mobbottomcube"
        alt="Hire3x 3D cube element - Bottom"
      />
      <img
        src="../../assets/imgs/Recruitment/transitionimages/cash.svg"
        class="animated-img mobbottomcash"
        alt="Hire3x cash icon - Bottom"
      />
      <img
        src="../../assets/imgs/Recruitment/transitionimages/pause.svg"
        class="animated-img mobbottompause"
        alt="Hire3x pause icon - Bottom"
      />
      <img
        src="../../assets/imgs/Recruitment/transitionimages/mobtopb.svg"
        class="animated-img mobbottomB"
        alt="Hire3x blue transition shape - Bottom B"
      />
      <img
        src="../../assets/imgs/Recruitment/transitionimages/msg.svg"
        class="animated-img mobbottommsg"
        alt="Hire3x message icon - Bottom"
      />
      <img
        src="../../assets/imgs/Recruitment/transitionimages/mobbottom1.svg"
        class="animated-img mobbottom1"
        alt="Hire3x transition element - Bottom 1"
      />
      <img
        src="../../assets/imgs/Recruitment/transitionimages/mobbottom2.svg"
        class="animated-img mobbottom2"
        alt="Hire3x transition element - Bottom 2"
      />
      <img
        src="../../assets/imgs/Recruitment/transitionimages/mobtoporange.svg"
        class="animated-img mobbottomorange"
        alt="Hire3x orange transition element - Bottom"
      />
      <img
        src="../../assets/imgs/Recruitment/transitionimages/mobtopgreeb.svg"
        alt="Hire3x green transition shape - Bottom stuck image"
        class="animated-img mobbottomstuckimg"
      />
    </div>

    <div id="mobilehidden">
      <img
        src="../../assets/imgs/Builderpage/opputunity/left1.svg"
        alt="Hire3x visual element - Left 1"
        class="animated-img left1"
      />
      <img
        src="../../assets/imgs/Builderpage/opputunity/left2.svg"
        alt="Hire3x visual element - Left 2"
        class="animated-img left2"
      />
      <img
        src="../../assets/imgs/Builderpage/opputunity/left3.svg"
        alt="Hire3x visual element - Left 3"
        class="animated-img left3"
      />
      <img
        src="../../assets/imgs/Builderpage/opputunity/mid1.svg"
        alt="Hire3x center graphic - Mid 1"
        class="animated-img mid1"
      />
      <img
        src="../../assets/imgs/Builderpage/opputunity/mid2.svg"
        alt="Hire3x center graphic - Mid 2"
        class="animated-img mid2"
      />
      <img
        src="../../assets/imgs/Builderpage/opputunity/mid3.svg"
        alt="Hire3x center graphic - Mid 3"
        class="animated-img mid3"
      />
      <img
        src="../../assets/imgs/Builderpage/opputunity/mid4.svg"
        alt="Hire3x center graphic - Mid 4"
        class="animated-img mid4"
      />
      <img
        src="../../assets/imgs/Builderpage/opputunity/right1.svg"
        alt="Hire3x visual element - Right 1"
        class="animated-img right1"
      />
      <img
        src="../../assets/imgs/Builderpage/opputunity/right2.svg"
        alt="Hire3x visual element - Right 2"
        class="animated-img right2"
      />
      <img
        src="../../assets/imgs/Builderpage/opputunity/right-3.svg"
        alt="Hire3x visual element - Right 3"
        class="animated-img right4"
      />
      <img
        src="../../assets/imgs/Builderpage/opputunity/right4.svg"
        alt="Hire3x visual element - Right 4"
        class="animated-img right3"
      />
    </div>

    <!-- </div> -->

    <div
      class="mob-px-3 d-flex flex-column justify-content-center h-100 align-items-center"
      style="max-width: 738px; z-index: 3"
    >
      <h1
        class="mob-pt0 joinhire3xtxt mob-fs-36 fw-700 fs-56 font-inter text-center mobpt-0"
      >
        {{ heading ? heading : "Join Hire3x" }}
      </h1>
      <h6
        class="fw-400 mob-fs-14 fs-20 font-inter color-white text-center z-ins-20 mob-w85"
      >
        {{
          text
            ? text
            : "At Hire3x, we focus on innovation, collaboration, growth, creativity, impact, and success."
        }}
      </h6>
      <div class="primary-bluebtn mob-w100 d-flex justify-content-center">
        <b-button
          variant="primary"
          class="w-200px"
          @click="
            from == 'recruitment' ? gotoRequest() : $emit('onboarding-modal')
          "
        >
          {{ btnText ? btnText : "Start Now" }}</b-button
        >
      </div>
    </div>
    <div class="position-relative right-0 h-100" id="mobilehidden">
      <img
        src="../../assets/imgs/Builderpage/opputunity/opputunityright/one.svg"
        alt="Hire3x opportunity graphic - Step 1"
        class="animated-img opR-one"
      />
      <img
        src="../../assets/imgs/Builderpage/opputunity/opputunityright/two.svg"
        alt="Hire3x opportunity graphic - Step 2"
        class="animated-img opR-two"
      />
      <img
        src="../../assets/imgs/Builderpage/opputunity/opputunityright/three.svg"
        alt="Hire3x opportunity graphic - Step 3"
        class="animated-img opR-three"
      />
      <img
        src="../../assets/imgs/Builderpage/opputunity/opputunityright/four.svg"
        alt="Hire3x opportunity graphic - Step 4"
        class="animated-img opR-four"
      />
      <img
        src="../../assets/imgs/Builderpage/opputunity/opputunityright/five.svg"
        alt="Hire3x opportunity graphic - Step 5"
        class="animated-img opR-five"
      />
      <img
        src="../../assets/imgs/Builderpage/opputunity/opputunityright/six.svg"
        alt="Hire3x opportunity graphic - Step 6"
        class="animated-img opR-six"
      />
      <img
        src="../../assets/imgs/Builderpage/opputunity/opputunityright/seven.svg"
        alt="Hire3x opportunity graphic - Step 7"
        class="animated-img opR-seven"
      />
      <img
        src="../../assets/imgs/Builderpage/opputunity/opputunityright/eight.svg"
        alt="Hire3x opportunity graphic - Step 8"
        class="animated-img opR-eight"
      />
      <img
        src="../../assets/imgs/Builderpage/opputunity/opputunityright/nine.svg"
        alt="Hire3x opportunity graphic - Step 9"
        class="animated-img opR-nine"
      />
      <img
        src="../../assets/imgs/Builderpage/opputunity/opputunityright/ten.svg"
        alt="Hire3x opportunity graphic - Step 10"
        class="animated-img opR-ten"
      />
      <img
        src="../../assets/imgs/Builderpage/opputunity/opputunityright/eleven.svg"
        alt="Hire3x opportunity graphic - Step 11"
        class="animated-img opR-eleven"
      />
      <img
        src="../../assets/imgs/Builderpage/opputunity/right2.svg"
        alt="Hire3x visual element - Final right graphic"
        class="animated-img opR-twelve"
      />
    </div>
  </section>
</template>

<script>
import "@/assets/css/builderpage.css";
import pageRoute from "@/utils/pageRoute";
export default {
  name: "OpportunityCard",
  mixins: [pageRoute],
  props: {
    heading: String,
    text: String,
    from: String,
    btnText: String,
  },
};
</script>

<style>
/* Common animation class for all images */
.opputunity-container {
  height: 460px;
  background: #0c1b24;
  z-index: 5;
}

.animated-img {
  position: absolute;
  animation-duration: 5s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
}

.joinhire3xtxt {
  letter-spacing: -0.03em;
  background: linear-gradient(180deg, #f6f6f7 0%, #7e808f 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  white-space: nowrap;
}

@media (max-width: 768px) {
  .joinhire3xtxt {
    white-space: normal;
    word-break: break-word;
    overflow-wrap: break-word;
  }
}

.opR-one {
  animation-name: moveOpr1;
}

.opR-two {
  animation-name: moveOpr2;
}

.opR-three {
  animation-name: moveOpr3;
}

.opR-four {
  animation-name: moveOpr4;
}

.opR-five {
  animation-name: moveOpr5;
}

.opR-six {
  /* animation-name: moveOpr6; */
  transform: translateY(100px) translateX(-155px);
}

.opR-seven {
  animation-name: moveOpr7;
}

.opR-eight {
  animation-name: moveOpr8;
}

.opR-nine {
  animation-name: moveOpr9;
}

.opR-ten {
  animation-name: moveOpr10;
  /* transform: translateY(385px) translateX(-210px); */
}

.opR-eleven {
  animation-name: moveOpr11;
}

.opR-twelve {
  animation-name: moveOpr12;
}

.left1 {
  animation-name: moveLeft1;
  /* transform: translateY(0px) translateX(155px); */
  /* transform: translateY(160px) translateX(0); */
}

.left2 {
  animation-name: moveLeft2;
  /* transform: translateY(30px) translateX(250px); */
}

.left3 {
  animation-name: moveLeft3;
  /* transform: translateY(5px) translateX(0px);
  transform: translateY(120px) translateX(63px); */
}

.mid1 {
  animation-name: moveMid1;
  /* transform: translateY(35px) translateX(160px); */
}

.mid2 {
  animation-name: moveMid2;
  /* transform: translateY(250px) translateX(145px); */
}

.mid3 {
  animation-name: moveMid3;
  /* transform: translateY(150px) translateX(220px); */
}

.mid4 {
  animation-name: moveMid4;
  /* transform: translateY(300px) translateX(250px); */
}

.right1 {
  animation-name: moveRight1;
  /* transform: translateY(215px) translateX(355px); */
}

.right2 {
  animation-name: moveRight2;
  /* transform: translateY(445px) translateX(385px); */
}

.right3 {
  animation-name: moveRight3;
}

.right4 {
  animation-name: moveRight4;
}

/* Keyframes for different image movements */
@keyframes moveLeft1 {
  0% {
    transform: translateY(280px) translateX(0);
  }

  50% {
    transform: translateY(160px) translateX(0);
  }

  100% {
    transform: translateY(280px) translateX(0);
  }
}

@keyframes moveLeft2 {
  0% {
    transform: translateY(395px) translateX(125px);
  }

  50% {
    transform: translateY(350px) translateX(125px);
  }

  100% {
    transform: translateY(395px) translateX(125px);
  }
}

@keyframes moveLeft3 {
  0% {
    transform: translateY(120px) translateX(63px);
  }

  50% {
    transform: translateY(101px) translateX(18px);
  }

  100% {
    transform: translateY(120px) translateX(63px);
  }
}

@keyframes moveMid1 {
  0% {
    transform: translateY(35px) translateX(160px);
  }

  50% {
    transform: translateY(60px) translateX(115px);
  }

  100% {
    transform: translateY(35px) translateX(160px);
  }
}

@keyframes moveMid2 {
  0% {
    transform: translateY(250px) translateX(145px);
  }

  50% {
    transform: translateY(195px) translateX(145px);
  }

  100% {
    transform: translateY(250px) translateX(145px);
  }
}

@keyframes moveMid3 {
  0% {
    transform: translateY(150px) translateX(220px);
  }

  50% {
    transform: translateY(150px) translateX(135px);
  }

  100% {
    transform: translateY(150px) translateX(220px);
  }
}

@keyframes moveMid4 {
  0% {
    transform: translateY(300px) translateX(250px);
  }

  50% {
    transform: translateY(235px) translateX(235px);
  }

  100% {
    transform: translateY(300px) translateX(250px);
  }
}

@keyframes moveRight1 {
  0% {
    transform: translateY(215px) translateX(355px);
  }

  50% {
    transform: translateY(150px) translateX(345px);
  }

  100% {
    transform: translateY(215px) translateX(355px);
  }
}

@keyframes moveRight2 {
  0% {
    transform: translateY(445px) translateX(385px);
  }

  50% {
    transform: translateY(445px) translateX(230px);
  }

  100% {
    transform: translateY(445px) translateX(385px);
  }
}

@keyframes moveRight3 {
  0% {
    transform: translateY(0) translateX(355px);
  }

  50% {
    transform: translateY(0) translateX(230px);
  }

  100% {
    transform: translateY(0) translateX(385px);
  }
}

@keyframes moveRight4 {
  0% {
    transform: translateY(85px) translateX(385px);
  }

  50% {
    transform: translateY(85px) translateX(255px);
  }

  100% {
    transform: translateY(85px) translateX(385px);
  }
}

@keyframes moveOpr1 {
  0% {
    transform: translateY(30px) translateX(-455px);
  }

  50% {
    transform: translateY(-40px) translateX(-455px);
  }

  100% {
    transform: translateY(30px) translateX(-455px);
  }
}

@keyframes moveOpr2 {
  0% {
    transform: translateY(65px) translateX(-310px);
  }

  50% {
    transform: translateY(-10px) translateX(-310px);
  }

  100% {
    transform: translateY(65px) translateX(-310px);
  }
}

@keyframes moveOpr3 {
  0% {
    transform: translateY(0px) translateX(-98px);
  }

  50% {
    transform: translateY(0px) translateX(-25px);
  }

  100% {
    transform: translateY(0px) translateX(-98px);
  }
}

@keyframes moveOpr4 {
  0% {
    transform: translateY(160px) translateX(-435px);
  }

  50% {
    transform: translateY(95px) translateX(-435px);
  }

  100% {
    transform: translateY(160px) translateX(-435px);
  }
}

@keyframes moveOpr5 {
  0% {
    transform: translateY(170px) translateX(-270px);
  }

  50% {
    transform: translateY(120px) translateX(-325px);
  }

  100% {
    transform: translateY(170px) translateX(-270px);
  }
}

/* @keyframes moveOpr6 {
  0% {
    transform: translateY(100px) translateX(-155px);
  }
  50% {
    transform: translateY(25px) translateX(-155px);
  }
  100% {
    transform: translateY(100px) translateX(-155px);
  }
} */
@keyframes moveOpr7 {
  0% {
    transform: translateY(295px) translateX(-230px);
  }

  50% {
    transform: translateY(240px) translateX(-320px);
  }

  100% {
    transform: translateY(295px) translateX(-230px);
  }
}

@keyframes moveOpr8 {
  0% {
    transform: translateY(215px) translateX(-85px);
  }

  50% {
    transform: translateY(185px) translateX(-180px);
  }

  100% {
    transform: translateY(215px) translateX(-85px);
  }
}

@keyframes moveOpr9 {
  0% {
    transform: translateY(305px) translateX(-345px);
  }

  50% {
    transform: translateY(250px) translateX(-410px);
  }

  100% {
    transform: translateY(305px) translateX(-345px);
  }
}

@keyframes moveOpr10 {
  0% {
    transform: translateY(385px) translateX(-210px);
  }

  50% {
    transform: translateY(335px) translateX(-150px);
  }

  100% {
    transform: translateY(385px) translateX(-210px);
  }
}

@keyframes moveOpr11 {
  0% {
    transform: translateY(415px) translateX(-135px);
  }

  50% {
    transform: translateY(360px) translateX(-25px);
  }

  100% {
    transform: translateY(415px) translateX(-135px);
  }
}

@keyframes moveOpr12 {
  0% {
    transform: translateY(445px) translateX(-85px);
  }

  50% {
    transform: translateY(445px) translateX(-245px);
  }

  100% {
    transform: translateY(445px) translateX(-85px);
  }
}

@media screen and (min-width: 601px) {
  #laptophidden {
    display: none !important;
  }

  .z-ins-20 {
    z-index: 20;
    position: relative;
  }
}

@media screen and (max-width: 600px) {
  #mobilehidden {
    display: none !important;
  }

  .opputunity-container {
    height: 460px;
  }

  .mobalign-center {
    align-items: center !important;
    /* justify-content: center !important; */
  }

  .mob-px-3 {
    padding: 0 1rem !important;
  }

  .mob-pt0 {
    padding-top: 0 !important;
  }

  .mobtop4 {
    animation-name: movetop4;
  }

  .mobtop5 {
    animation-name: movetop5;
  }

  .mobtop6 {
    animation-name: movetop6;
  }

  .mobtop7 {
    animation-name: movetop7;
  }

  .mobtop8 {
    animation-name: movetop8;
  }

  /* Keyframes for different image movements */
  @keyframes moveLeft1 {
    0% {
      transform: translateY(0px) translateX(155px);
    }

    50% {
      transform: translateY(-30px) translateX(155px);
    }

    100% {
      transform: translateY(0px) translateX(155px);
    }
  }

  @keyframes moveLeft2 {
    0% {
      transform: translateY(30px) translateX(250px);
    }

    50% {
      transform: translateY(-10px) translateX(250px);
    }

    100% {
      transform: translateY(30px) translateX(250px);
    }
  }

  @keyframes moveLeft3 {
    0% {
      transform: translateY(5px) translateX(0px);
    }

    50% {
      transform: translateY(5px) translateX(0px);
    }

    100% {
      transform: translateY(5px) translateX(0px);
    }
  }

  @keyframes movetop4 {
    0% {
      transform: translateY(10px) translateX(310px);
    }

    50% {
      transform: translateY(50px) translateX(310px);
    }

    100% {
      transform: translateY(10px) translateX(310px);
    }
  }

  @keyframes movetop5 {
    0% {
      transform: translateY(10px) translateX(310px);
    }

    50% {
      transform: translateY(50px) translateX(310px);
    }

    100% {
      transform: translateY(10px) translateX(310px);
    }
  }

  @keyframes movetop5 {
    0% {
      transform: translateY(65px) translateX(220px);
    }

    50% {
      transform: translateY(65px) translateX(315px);
    }

    100% {
      transform: translateY(65px) translateX(220px);
    }
  }

  @keyframes movetop6 {
    0% {
      transform: translateY(70px) translateX(40px);
    }

    50% {
      transform: translateY(85px) translateX(-10px);
    }

    100% {
      transform: translateY(70px) translateX(40px);
    }
  }

  @keyframes movetop7 {
    0% {
      transform: translateY(80px) translateX(290px);
    }

    50% {
      transform: translateY(80px) translateX(145px);
    }

    100% {
      transform: translateY(80px) translateX(290px);
    }
  }

  @keyframes movetop8 {
    0% {
      transform: translateY(30px) translateX(85px);
    }

    50% {
      transform: translateY(30px) translateX(115px);
    }

    100% {
      transform: translateY(30px) translateX(85px);
    }
  }

  .mobbottomcube {
    animation-name: movebottomcube;
    /* transform: translateY(365px) translateX(385px); */
  }

  .mobbottomcash {
    animation-name: movebottomcash;
    /* transform: translateY(373px) translateX(45px); */
  }

  .mobbottompause {
    animation-name: movebottompause;
    /* transform: translateY(435px) translateX(-60px); */
  }

  .mobbottomB {
    animation-name: movebottomB;
    /* transform: translateY(365px) translateX(300px); */
  }

  .mobbottommsg {
    animation-name: movebottommsg;
    /* transform: translateY(370px) translateX(175px); */
  }

  .mobbottom1 {
    /* transform: translateY(310px) translateX(-20px); */
    animation-name: movebottom1;
  }

  .mobbottomstuckimg {
    transform: translateY(350px) translateX(285px);
  }

  .mobbottom2 {
    animation-name: movebottom2;
    /* transform: translateY(330px) translateX(85px); */
  }

  .mobbottomorange {
    animation-name: movebottomorange;
    /* transform: translateY(320px) translateX(245px); */
  }

  @keyframes movebottomcube {
    0% {
      transform: translateY(400px) translateX(280px);
    }

    50% {
      transform: translateY(400px) translateX(220px);
    }

    100% {
      transform: translateY(400px) translateX(280px);
    }
  }

  @keyframes movebottomcash {
    0% {
      transform: translateY(373px) translateX(45px);
    }

    50% {
      transform: translateY(373px) translateX(120px);
    }

    100% {
      transform: translateY(373px) translateX(45px);
    }
  }

  @keyframes movebottommsg {
    0% {
      transform: translateY(385px) translateX(155px);
    }

    50% {
      transform: translateY(410px) translateX(155px);
    }

    100% {
      transform: translateY(385px) translateX(155px);
    }
  }

  @keyframes movebottompause {
    0% {
      transform: translateY(435px) translateX(0px);
    }

    50% {
      transform: translateY(435px) translateX(70px);
    }

    100% {
      transform: translateY(435px) translateX(0px);
    }
  }

  @keyframes movebottomB {
    0% {
      transform: translateY(365px) translateX(315px);
    }

    50% {
      transform: translateY(425px) translateX(295px);
    }

    100% {
      transform: translateY(365px) translateX(315px);
    }
  }

  @keyframes movebottom1 {
    0% {
      transform: translateY(310px) translateX(0px);
    }

    50% {
      transform: translateY(355px) translateX(20px);
    }

    100% {
      transform: translateY(310px) translateX(0px);
    }
  }

  @keyframes movebottom2 {
    0% {
      transform: translateY(395px) translateX(85px);
    }

    50% {
      transform: translateY(330px) translateX(85px);
    }

    100% {
      transform: translateY(395px) translateX(85px);
    }
  }

  @keyframes movebottomorange {
    0% {
      transform: translateY(340px) translateX(195px);
    }

    50% {
      transform: translateY(440px) translateX(195px);
    }

    100% {
      transform: translateY(340px) translateX(195px);
    }
  }
}

@media screen and (min-width: 401px) and (max-width: 500px) {
  .biggerphones-alignment {
    width: 100%;
    position: relative;
    left: 10%;
  }
}
@media screen and (min-width: 501px) and (max-width: 600px) {
  .biggerphones-alignment {
    width: 100%;
    position: relative;
    left: 15%;
  }
}
@media (min-width: 601px) {
  .lapflex-between {
    display: flex;
    justify-content: space-between;
  }
  .frommobile-alignunset {
    align-items: unset !important;
  }
}
</style>
